import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { type AdvisoryNeedDto, getAdvisoryNeedsContentForTalkingPoint } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useContentByTalkingPointIdAndDomicile(talkingPointId?: number, domicile?: string): UseQueryResult<AdvisoryNeedDto[], AxiosError> {
    const queryKey = useMemo(() => queryKeys.contentByTalkingPointIdAndDomicile(talkingPointId, domicile), [talkingPointId, domicile]);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) =>
            getAdvisoryNeedsContentForTalkingPoint({ path: { talkingPointId: talkingPointId! }, query: { domicile: domicile! }, signal }).then(
                (result) => result.data,
            ),
        enabled: !!talkingPointId && !!domicile,
    });
}
